import type { ColorsType } from "Infrastructure/Themes/Themes";

export const colors = (): ColorsType => ({
  BrandPrimary: "#FF8647",
  BrandMedium: "#C62B08",
  BrandLight: "#FFF5ED",
  BrandLighter: "#FFFAF6",
  BrandLightBorder: "#FBE3D2",
  SuccessPrimary: "#41B871",
  SuccessMedium: "#367C50",
  SuccessLight: "#D1FAE5",
  InfoPrimary: "#3B82F6",
  InfoMedium: "#293E7A",
  InfoLight: "#DBEAFE",
  InfoSuperLight: "#eef5fd",
  Warning: "#F5D90A",
  WarningLight: "#FFFBD1",
  WarningMedium: "#946800",
  DangerDark: "#B91C1C",
  DangerPrimary: "#EF4444",
  DangerLight: "#FEE2E2",
  TextPrimary: "#2C2E30",
  TextSecondary: "#A0A3A6",
  TextTertiary: "#F1F3F7",
  TextDisabled: "#A3A3A3",
  TextHint: "#D9DBDD",
  TextInverse: "#FFFFFF",
  Border: "#E7E8E9",
  BorderLight: "#E7E8E9",
  BorderDisabled: "#D4D4D4",
  BackgroundLight: "#fcfcfc",
  BackgroundSecondary: "#FAFAFA",
  BackgroundTertiary: "#F1F3F7",
  Green: "#41B871",
  PrimaryHover: "#FE5811",
  PrimaryDisabled: "#F5F5F5",
  Body: "#ffffff",
  Black: "#000000",
  White: "#ffffff",
  Gray: "#F1F5F9",
  DarkGrey: "#334155",
  Validation: "#FF6690",
  Placeholder: "#8E98A7",
  FieldBackground: "#F8FAFC",
  ContentWrapperBorder: "#E2E8F0",
  RadioBtnDisabled: "#EBEEF1",
  WorkflowIcon: "#DFE5F1",
  ChartPositive: "#00876C",
  ChartPositiveLight: "#93C3B3",
  ChartPositiveLighter: "#B7D7CC",
  ChartNeutral: "#FF8647",
  ChartNeutralLight: "#FFAF83",
  ChartNeutralLighter: "#FFD7C0",
  ChartNegative: "#D43D51",
});
